export default __webpack_public_path__ + "static/media/cwu19.3ac60214.jpeg";